import { Action, createReducer, on } from '@ngrx/store';

import {
  activeDefaultAddressesSuccessAction,
  createDefaultAddressesSuccessAction,
  loadUserAddressesSuccessAction,
  setDefaultAddressAction
} from '@app/store/actions/global.actions';
import { UserAddresses, Address } from '@app/modules/core/interfaces/address';

export const initialState: UserAddresses = {} as UserAddresses;

const featureReducer = createReducer(
  initialState,
  on(loadUserAddressesSuccessAction, (state, { addresses }) => {
    return { ...state, addresses: addresses.addresses };
  }),
  on(activeDefaultAddressesSuccessAction, (state, { response }) => {
    return { ...state, activeAddress: response ?? {} as Address };
  }),
  on(createDefaultAddressesSuccessAction, (state, { response }) => {
    return {
      ...state, addresses: [response.address], activeAddress: response?.address ?? {} as Address
    };
  }),
  on(setDefaultAddressAction, (state, { address }) => {
    return { ...state, activeAddress: address ?? {} as Address };
  }),
);

export const userAddressesReducer = (state: UserAddresses, action: Action): UserAddresses => {
  return featureReducer(state, action);
};
